var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.994,
    viewBox: "0 0 16 15.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M16.671,7.857l-11.2-5.6a2.4,2.4,0,0,0-3.264,3.12l1.92,4.3h0a.848.848,0,0,1,0,.656l-1.92,4.3A2.4,2.4,0,0,0,4.4,18a2.512,2.512,0,0,0,1.08-.256l11.2-5.6a2.4,2.4,0,0,0,0-4.288Zm-.712,2.856-11.2,5.6a.8.8,0,0,1-1.08-1.04l1.912-4.3a1.6,1.6,0,0,0,.064-.176h5.512a.8.8,0,0,0,0-1.6H5.656a1.6,1.6,0,0,0-.064-.176L3.68,4.729a.8.8,0,0,1,1.08-1.04l11.2,5.6a.8.8,0,0,1,0,1.424Z",
    transform: "translate(-2.001 -2.006)",
    fill: "#616161"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.d3b208f432946b876bf63b6f6dd0a786.svg";
export { ForwardRef as ReactComponent };